// extracted by mini-css-extract-plugin
export default {"root":"bcT5I","item":"XU9Tt","link":"eXgBd"};